@if(isLoading){
<div class="mi-products">
    <mi-genral-skeleton></mi-genral-skeleton>
</div>

}
@else{
<div class="mi-products container" tabindex="-1" miFocusOnTab>
    <div class="mi-panel-wrraper standart">
        <div class="row justify-content-center">
            <div class="col-12 mi-panel-content">

                <div class="mi-header-wrraper mc-my-3">
                    <span class="mi-header">{{productTitle}}</span>
                    @if(!isSingleProduct()){
                    <mc-button [label]="'מחיקת מוצר'" [ariaLabel]="'מחיקת מוצר'"
                        class="mi-white-button mi-remove-product" [icon]="'icon-trash-2'"
                        (click)="deleteProduct()"></mc-button>
                    }
                </div>

                <div class="mi-white-panel with-shadow">

                    <div class="mi-back ">
                        <mc-button [label]="genericText?.back" [ariaLabel]="genericText?.back"
                            [icon]="'pi pi-fw pi-chevron-right'" class="mi-button-with-icon-primary"
                            id="mi-product-back" (click)="previousTab()" (keyup.enter)="previousTab()"></mc-button>
                    </div>

                    @if (this.formisForm.fields.length> 0) {
                    <mc-field-form [formisForm]="formisForm">
                    </mc-field-form> }

                </div>

            </div>
        </div>

        <div class="row justify-content-center justify-content-md-start ">
            <div class="col-12 col-md-8 col-xl-4">
                @if(maxProductsReached && isLastProduct()){
                <div class="mc-pt-3">
                    <mc-info level="warning" class="col-12  mc-mt-4 mc-pt-1">
                        {{maxProductsInfoMessage()}}
                    </mc-info>
                </div>
                }
                <div class="mi-product-navigation row justify-content-center   mc-pt-1">
                    <div class=" col-6 mi-add-product">
                        <mc-button [disabled]="maxProductsReached|| !isLastProduct()" [label]="productsText?.addProduct"
                            [ariaLabel]="productsText?.addProduct" (click)="createNewProduct()"
                            [id]="'mi-add-product'"></mc-button>
                    </div>
                    <div class="  col-6 mi-next">
                        <mc-button [label]="genericText?.next + ' >'" (click)="nextTab()"
                            [id]="'mi-next-product'"></mc-button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}
<mc-dialog [dialogProperties]="dialogProperties">
    <div class="d-flex flex-column mi-remove-product-dialog">
        <h2> {{productsText.dialogRemoveProduct?.textPart1}}</h2>
        <span>{{productsText.dialogRemoveProduct?.textPart2}} </span>
    </div>
</mc-dialog>